module.exports = __webpack_public_path__ + "Icono_RolGuardia_512.png";